import { useEffect, useState } from 'react';
import { getSettingsOverview } from '../api/settings.api';
import type { SettingsOverview } from '../types/settings.types';

export function useSettings() {
  const [settings, setSettings] = useState<SettingsOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getSettingsOverview()
      .then(setSettings)
      .catch(() => setError('خطا در دریافت تنظیمات'))
      .finally(() => setLoading(false));
  }, []);

  return { settings, loading, error };
}
